// removed by extract-text-webpack-plugin
module.exports = {"gray-container":"TechnicalDocument-module-gray-container-O4cqU","grayContainer":"TechnicalDocument-module-gray-container-O4cqU"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalDocument/TechnicalDocument.module.scss
// module id = 1321
// module chunks = 0